/**
* Projects Slider JS
* -----------------------------------------------------------------------------
*
* All the JS for the Projects Slider component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
import Splide from '@splidejs/splide';
( function( app ) {
  const COMPONENT = {

    className: 'projects-slider',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      $( '.projects-slider' ).each( function( key, component ) {
        const splide = new Splide( $( component ).find( '.splide--projects-slider' )[0], {
          pagination: false,
          arrows: true,
          gap: '32px',
          autoWidth: false,
          perPage: 2,
          perMove: 1,
          breakpoints: {
            1024: {
              perPage: 1,
            },
          },
        } );

        splide.mount();
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'projects-slider', COMPONENT );
} )( app );
